import { SurveyData } from "../components/survey/survey";
import { API_URL } from "./api";

export type Answer = {
    questionId: string;
    type: "Answer" | "Distractor 1" | "Distractor 2";
};

export type SubmitDataDTO = {
    surveyData: SurveyData;
    answers: Answer[];
};

const submitAnswers = async (data: SubmitDataDTO) => {
    const res = await fetch(`${API_URL}/answers`, {
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    }).then(
        response => {
            return response;
        },
        err => {
            console.log(err);
        }
    );
    return res;
};

export default submitAnswers;
